<template>
  <div
    class="card bloco-card"
    :class="classesCss"
    @click="ativarCard"
>
    <p v-text="card.titulo" class="mb-0 mt-1 font-14" />
    <v-progress-linear v-if="qtd_produtos === null" color="red" indeterminate class="mt-3" />
    <p v-else v-text="qtd_produtos" class="mb-0 font-20 font-weight-bold" />
  </div>
</template>

<script>
import {parametros_rota} from "../helpers/ParametrosRota.js";
import {data_table_departamentos_carregando_dados} from "../../../utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js";
import {logout} from "../../../../helpers";

export default {
  name: "CardTotalizador",
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  mixins: [parametros_rota, data_table_departamentos_carregando_dados],
  props: {
    modelValue: Object,
    card: {
      type: Object,
      required: true
    },
    atualizar_cards_count: Number
  },
  data: () => ({
    qtd_produtos: null
  }),
  computed: {
    classesCss() {
      const ativar_cursor_progresso = this.data_table_departamentos_carregando_dados || this.qtd_produtos === null;

      return {
        ativo: this.modelValue === this.card,
        inativo: this.modelValue !== this.card,
        'cursor-pointer': !ativar_cursor_progresso,
        'cursor-progress': ativar_cursor_progresso
      }
    }
  },
  watch: {
    grupo_compra() {
      this.buscarQtdProdutos();
    },
    filial_compra() {
      this.buscarQtdProdutos();
    },
    departamento_compra() {
      this.buscarQtdProdutos();
    },
    atualizar_cards_count() {
      this.buscarQtdProdutos();
    }
  },
  created() {
    this.buscarQtdProdutos();
  },
  methods: {
    async buscarQtdProdutos() {
      this.qtd_produtos = null;
      this.qtd_produtos = await this.card
        .buscarDados(this.grupo_compra, this.filial_compra, this.departamento_compra)
        .catch(logout);
    },
    ativarCard() {
      if (this.data_table_departamentos_carregando_dados) return;

      this.$emit('update:modelValue', this.card);
    }
  }
}
</script>

<style scoped>
.bloco-card {
  width: 175px;
  height: 62px;
  border-radius: 8px;
  padding: 5px 10px;
}
.card {
  position: relative;
  box-shadow: 0 3px 2px 0 #22222245;
}
.ativo {
  background: #043554;
  color: white;
  transition: .3s;
}
.inativo {
  background: white;
  color: #222222;
  transition:  .3s;
}
</style>
